import React from 'react';
import { Pane, Heading, Button, Text } from 'evergreen-ui';
import { CsvImportProvider } from '../context/CsvImportContext';
import CsvImportPage from '../CsvImportPage';

/**
 * Creator-specific CSV import page
 *
 * @param {Object} props - Component props
 * @param {Function} props.onClose - Function to call when the import is closed
 */
const CreatorImportPage = ({ onClose }) => {
  return (
    <CsvImportProvider>
      <Pane>
        {/* <Pane
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          marginBottom={16}
          borderBottom="1px solid #EDF0F2"
          paddingBottom={16}
        >
          <Heading size={700}>Import Creators from CSV</Heading>
          <Button appearance="minimal" iconBefore="cross" onClick={onClose}>
            Close
          </Button>
        </Pane>

        <Pane marginBottom={24}>
          <Text>
            Import your creator data from a CSV file. Follow the steps below to map your CSV columns
            to creator fields, validate the data, and import it into your account.
          </Text>
        </Pane> */}

        <CsvImportPage
          entityType="creator"
          onComplete={onClose}
          requiredFields={[
            { name: 'name', label: 'Name' },
            { name: 'email', label: 'Email' },
          ]}
          optionalFields={[
            { name: 'phone', label: 'Phone' },
            { name: 'address', label: 'Address' },
            { name: 'bio', label: 'Biography' },
            { name: 'website', label: 'Website' },
            { name: 'social_media', label: 'Social Media' },
            { name: 'payment_info', label: 'Payment Information' },
            { name: 'tax_id', label: 'Tax ID' },
            { name: 'notes', label: 'Notes' },
          ]}
        />
      </Pane>
    </CsvImportProvider>
  );
};

export default CreatorImportPage;
